module.exports = __webpack_public_path__ + "e106447d754aaad1af74492c1b2f7ba7.svg";